import * as React from 'react';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';

export default function SelectDateTime({ label, value, name, handleOnChange , disabled = false, minDate}) {
  const today = dayjs();
  const minAllowedDate = minDate ? dayjs(minDate).startOf('minute') : null;
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DemoContainer components={['DateTimePicker']}>
      <DateTimePicker
        size="small"
        label={label}
        format="DD/MM/YYYY HH:mm"
        value={value ? dayjs(value) : null}
        minDate={minAllowedDate} // Prevents selecting dates before minDate
        shouldDisableDate={(date) => dayjs(date).isBefore(minAllowedDate, 'day')} // Disable past dates
        shouldDisableTime={(value, view) => {
          const selectedDate = dayjs(value);
          const isSameDay = selectedDate.isSame(minAllowedDate, 'day');

          if (isSameDay) {
            if (view === 'hours' && selectedDate.hour() < minAllowedDate.hour()) {
              return true; // Disable hours before minDate
            }
            if (view === 'minutes' && selectedDate.hour() === minAllowedDate.hour() && selectedDate.minute() < minAllowedDate.minute()) {
              return true; // Disable minutes before minDate
            }
          }
          return false;
        }}
        slotProps={{ textField: { size: 'small' } }}
        disabled={disabled}
        onChange={(newValue) => {
          handleOnChange(dayjs(newValue).format('YYYY/MM/DD HH:mm'), name);
        }}
      />
    </DemoContainer>
  </LocalizationProvider>
  )
}
